
<div (click)="$event.stopPropagation()">
  <!-- <button class="close-button" (click)="onCloseClick()">
  <span aria-hidden="true">&times;</span>
</button>
<h1 mat-dialog-title>Update your {{sendMethod}}</h1> -->
<child-header title="Update your {{sendMethod}}" (closeEvent)="onCloseClick()"></child-header>
<div class="mat-dialog-body">
  <div mat-dialog-content>
    <div class="row" *ngIf="sendMethod=='mobile'">
      <div class="col-md-12 form-label">
        MOBILE NUMBER
      </div>
      <div class="col-md-12">
        <mat-form-field>
          <input matInput integerOnly type="text" class="poReference" [(ngModel)]="mobileNumber"/>
        </mat-form-field>
      </div>
    </div>
    <div class="row" *ngIf="sendMethod=='email'">
      <div class="col-md-12 form-label">
        EMAIL ADDRESS
      </div>
      <div class="col-md-12">
        <mat-form-field>
          <input matInput type="email" class="poReference" [(ngModel)]="emailAddress"/>
        </mat-form-field>
      </div>
    </div>
    <div class="row">
      <span class="grey-text">*We will send an OTP to validate this {{sendMethod}}</span>
    </div>
  </div>
  <div mat-dialog-actions>
    <button mat-button class="button button-red button-large continue" (click)="updateUserInfo()">Confirm</button>
  </div>
  </div>
</div>